import _ from 'lodash';
import { number, object } from 'yup';

import { DRAW_REQUEST_STATUS_OPTIONS } from '../../Servicing.constants';

export const drawRequestSchema = object().shape({
  requestedAmount: number()
    .typeError('Amount must be a number')
    .positive('Amount must be positive')
    .required('Requested amount is required'),
});

export const OBSERVABLE_FIELDS = ['requestedAmount', 'status', 'notes'];

export const statusOptionMap = _.keyBy(DRAW_REQUEST_STATUS_OPTIONS, 'value');
